import { ISignInRequest } from '../authentication/authentication.types'
import { IError } from '../base/error'
import ServiceBase from '../base/service.base'

import { RequestAgentDTO, IUserUpdateDTO } from './user.types'

export class User extends ServiceBase {
  private mainURL = '/user'

  /**
   * Get logged user information
   *
   */
  public async user(): Promise<RequestAgentDTO> {
    const url = `${this.mainURL}`

    const response = await this.request.get<RequestAgentDTO, IError>(url)

    if (response.result) {
      return response.result
    } else {
      const error = response.error as IError
      throw new IError(error.statusCode, error.message, error.error)
    }
  }

  public async acceptServiceTerms(
    data: ISignInRequest,
    companyId: string,
  ): Promise<boolean> {
    const url = `${this.mainURL}/accept-service-terms/${companyId}`

    const response = await this.request.patch<boolean, IError>(url, data)

    if (response.status === 200) {
      return true
    } else {
      const error = response.error as IError
      throw new IError(error.statusCode, error.message, error.error)
    }
  }

  public async updateUser(data: IUserUpdateDTO): Promise<boolean> {
    const url = `${this.mainURL}`

    const response = await this.request.patch<boolean, IError>(url, data)

    if (response.status === 200) {
      return true
    } else {
      const error = response.error as IError
      throw new IError(error.statusCode, error.message, error.error)
    }
  }

  public async recoveryPassword(email: string): Promise<boolean> {
    const url = `${this.mainURL}/recovery/password`

    const response = await this.request.post<boolean, IError>(url, { email })

    if (response.status === 201) {
      return true
    } else {
      const error = response.error as IError
      throw new IError(error.statusCode, error.message, error.error)
    }
  }

  public async updateRecoveryPassword(
    token: string,
    email: string,
    newPassword: string,
  ): Promise<boolean> {
    const url = `${this.mainURL}/recovery/password`

    const response = await this.request.patch<boolean, IError>(url, {
      email,
      token,
      newPassword: newPassword,
    })

    if (response.status === 200) {
      return true
    } else {
      const error = response.error as IError
      throw new IError(error.statusCode, error.message, error.error)
    }
  }
}
